
import React, {useState } from "react";
import { Formik } from "formik";
import webRootContext from "../components/webrootcontext/WebRootContext";
import CollapseBar from "../framework/CollapseBar";
import Button from "../framework/Button";
import FileUpload from "../framework/FileUpload";
import Ribbon from "../framework/Ribbon";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function UpdateApplicationDocuments(props) {

    const invalidFileErrorMessage = "Upload a .pdf (limit 1 file under 2 MB)";
    const invalidFileLength = "The file name must be under 60 characters. Delete the file and upload a new one.";
    const sopErrorMessage = "Statement of purpose is required";
    const losErrorMessage = "Letter of support is required";
    const fileUploadInstructionMessage = 'Drag & Drop your file or <span class="filepond--label-action">Browse</span>';
    const fileUploadApi = webRootContext + "/rest/fileUploadService/fileUpload/";
    const dashboardUrl = webRootContext + '/ApplicantDashboard';
    const updateApplicationUrl = webRootContext + '/rest/application/updateApplicationDocuments';
    const errApi = "Error saving documents.";

    const history = useHistory();

    const [saveSuccess, setSaveSuccess] = useState();
    const [saveFailed, setSaveFailed] = useState();
    const [formikError, setFormikError] = useState();
    const [formSubmitted, setFormSubmitted] = useState();
    const [responseError, setResponseError] = useState();
    const [needStmtOfPurpose, setNeedStmtOfPurpose] = useState(history.location.state.data.dashboard.requestNewStatementPurpose);
    const [statementOfPurposeUploaded, setStatementOfPurposeUploaded] = useState(false);
    const [needLetterOfSupport, setNeedLetterOfSupport] = useState(history.location.state.data.dashboard.requestNewLetterSupport);
    const [letterOfSupportUploaded, setLetterOfSupportUploaded] = useState(false);
	const [successMsg, setSuccessMsg] = useState("");


    const checkKeyDown = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    }

    function returnToDashboard() {
        window.location.href = dashboardUrl;
    }

    function submitUpdatedDocuments() {
        let requestURL = updateApplicationUrl;
        requestURL += "?los=" + needLetterOfSupport + "&sop=" + needStmtOfPurpose;

        fetch(requestURL, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            mode: "cors"
        })
            .then((response) => {
                if (response.ok) {
                    setSaveSuccess(true);
                    setSaveFailed(false);
					
					let msg = <div>Thank you for submitting the {needLetterOfSupport === 1 ? lblLetterOfSupport : ''} {(needLetterOfSupport === 1 && needStmtOfPurpose === 1) ? ' and ' : ''} {needStmtOfPurpose === 1 ? lblStatementOfPurpose : ''}</div>;
					setSuccessMsg(msg);
					
                    setNeedLetterOfSupport(0);
                    setNeedStmtOfPurpose(0);
                    setResponseError("");
                    setFormikError(false);
                } else {
                    setSaveSuccess(false);
                    setSaveFailed(true);
                    setResponseError("REVIEW ISSUES BELOW");
                }
                return response.json();
            })
            .catch((err) => {
                setResponseError(errApi);
            });
    };

    const lblLetterOfSupport = <b>Letter of Support</b>;
    const lblStatementOfPurpose = <b>Statement of Purpose</b>;

    const alreadySubmittedContent =
        <div>
            <div className="padding-bottom-30">This task has already been submitted.</div>
            <Button
                text={"RETURN TO DASHBOARD"}
                styleName={"button button--primary"}
                id={"button_submit"}
                type="submit"
                onClick={(e) => { returnToDashboard(); }}
            />
        </div>;

    const successMsgContent = <div>
        <div className="padding-bottom-30">{successMsg}</div>
        <div>
            <Button text={"RETURN TO DASHBOARD"} styleName={"button button--primary"} id={"returnForm"} onClick={returnToDashboard} />
        </div>
    </div>;

    return (
        <div>
            <div id="completed" className={(!saveSuccess && (needLetterOfSupport === 0 && needStmtOfPurpose === 0)) ? 'show_div' : 'hide_div'}>
                <div id="alreadySubmittedDiv" className="div_1_col">
                    <Ribbon label="SUBMITTED" status={"checkmark"} subheader={""} content={alreadySubmittedContent} />
                </div>
            </div>

            <div id="submitSuccess" className={(saveSuccess ? 'show_div' : 'hide_div')}>
                <div id="successDiv" className="div_3_col">
                    <Ribbon label={"Submitted"} status={"checkmark"} subheader={""} content={successMsgContent} />
                </div>
            </div>
            <div id="submitFailed" className={(saveFailed ? 'show_div' : 'hide_div')}>
                <div id="failDiv" className="div_1_col">
                    <Ribbon label={responseError} status={"error"} subheader={""} content={""} />
                </div>
            </div>
            <div className={(saveSuccess || (needLetterOfSupport === 0 && needStmtOfPurpose === 0) ? 'hide_div' : 'show_div')}>
                <Formik
                    enablereinitialize={true}
                    initialValues={{
                        sopUploaded: "",
                        losUploaded: "",

                    }}
                    validate={values => {
                        const errors = {};

                        // using values.sopUploaded doesn't work. we have to use a flag to do the check
                        if (needStmtOfPurpose === 1 && statementOfPurposeUploaded !== true) {
                            errors.sopUploaded = sopErrorMessage;
                        }

                        // using values.losUploaded doesn't work. we have to use a flag to do the check
                        if (needLetterOfSupport === 1 && letterOfSupportUploaded !== true) {
                            errors.losUploaded = losErrorMessage;
                        }
                        if (Object.keys(errors).length > 0) {
                            setFormikError("REVIEW ISSUES BELOW");
                        } else {
                            setFormikError("");
                        }

                        return errors;

                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setTimeout(() => {
                            setResponseError("");
                            submitUpdatedDocuments();
                            setSubmitting(false);
                        }, 100);
                    }}

                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        isValid,
                        dirty,
                        validateForm,
                        setFieldError
                    }) => (
                        <div>
                            <form onSubmit={handleSubmit} onKeyDown={(e) => checkKeyDown(e)} noValidate>
                                <div>
                                    <div id="formikErrors" className={(formikError && formSubmitted ? 'show_div' : 'hide_div')}>
                                        <div id="formikFailDiv" className="div_1_col">
                                            <Ribbon label={"REVIEW ISSUES BELOW"} status={"error"} subheader={""} content={""} />
                                        </div>
                                    </div>
                                </div>
                                {/* className={(saveSuccess || (needLetterOfSupport === 0 && needStmtOfPurpose === 0) ? 'hide_div' : 'show_div')}*/}
                                <div >
                                    <div id="headerDiv" className="div_1_col">
                                        <div className="breadcrumbLink"><a href={dashboardUrl} onClick={(e) => { returnToDashboard(); }}>Dashboard</a></div>
                                        <div className="page_title padding-bottom-30">Edit Observership Program Application</div>
                                    </div>
                                    <div id="divPageInfo" className="div_3_col padding-bottom-30 normal_txt">Please resubmit your {needLetterOfSupport === 1 ? lblLetterOfSupport : ""} {(needLetterOfSupport === 1 && needStmtOfPurpose === 1) ? " and " : ""} {needStmtOfPurpose === 1 ? lblStatementOfPurpose : ""}</div>
                                    <CollapseBar
                                        id={"cb1"}
                                        title={"Required documents"}
                                        showNewLink={false}
                                        showMoveTop={false}
                                        showCollapseBT={false}
                                        initStateExpand={true}
                                    />
                                    <div className="div_3_col">
                                        <div class="normal_txt padding-bottom-10">
                                            Documents must be uploaded as PDF files.<a href="https://www.freepdfconvert.com/" target="_blank" rel="noopener noreferrer"> Convert or create PDF files</a>
                                        </div>
                                        <div className={needStmtOfPurpose === 1 ? "show_div" : "hide_div"}>
                                            <div class="normal_txt padding-bottom-20">
                                                <h3 className="color--boston-pink padding-top-30 padding-bottom-20">Statement of Purpose</h3>
												<p>Your statement should be 1-2 pages and describe the following: (1) your current position, clinical responsibilities, and professional background; (2) your experience and interest in the pediatric subspecialty you are applying to; (3) three specific clinical learning objectives you hope to achieve during an observership; and (4) how you aim to apply the knowledge and practices observed at Boston Children's Hospital to your clinical practice.</p>
												<p>Please note that observerships are strictly observational, hand-on practice and research activities are not permitted. Learning objectives should be specific to the selected subspecialty and should clearly describe what you hope to observe, learn, or better understand during your visit. If applicable, please include explanation of any time gaps in your resume.</p>
                                            </div>

                                            <div>
                                                <FileUpload
                                                    id="sopUploaded"
                                                    label={"Upload statement of purpose"}
                                                    name="sopUploaded"
                                                    isRequired={(needStmtOfPurpose === 1)}
                                                    numberOfFiles={1}
                                                    fileSize={"2MB"} // default 5MB each file
                                                    fileType={["pdf"]}
                                                    maxFileNameLength={60} //Database column that stores the file name is limited to 100	
                                                    instructionMessage={fileUploadInstructionMessage}
                                                    helpMessage={"File format: .pdf (limit 1 file under 2 MB)"}
                                                    hasError={touched.sopUploaded && errors.sopUploaded}
                                                    errorMessage={errors.sopUploaded}
                                                    uploadApi={fileUploadApi + "sop"}
                                                    onChange={(e) => {
                                                        // e is an array of loaded file items
                                                        let tmp = e && e.length > 0 && e[0] !== 'F' && e[0].filename.length < 60;
                                                        setStatementOfPurposeUploaded(tmp ? true : false);

                                                        touched.sopUploaded = true;
                                                        if (!tmp) {
                                                            if (e.length === 0) {
                                                                setFieldError("sopUploaded", sopErrorMessage);
                                                            }
                                                            else if (e[0].filename.length > 60) {
                                                                setFieldError("sopUploaded", invalidFileLength);	//need to display field error when fileupload on change	
                                                            }
                                                            else {
                                                                setFieldError("sopUploaded", invalidFileErrorMessage);	//need to display field error when fileupload on change							
                                                            }
                                                        } else {
                                                            setFieldError("sopUploaded", null);
                                                        }
                                                    }}
                                                    onBlur={(e) => { }}
                                                />
                                                <hr className={needLetterOfSupport === 1 ? "hr--dot-boston-pink" : "hr--light"} />
                                            </div>
                                        </div>

                                        <div className={needLetterOfSupport === 1 ? "show_div" : "hide_div"}>
                                            <div class="normal_txt padding-bottom-20">
                                                <h3 className="color--boston-pink padding-top-30 padding-bottom-20">Letter of Support</h3>
                                                This letter should be written by your current supervisor at your place of employment where you are currently training or practicing and show that you are authorized to temporarily leave your duties for an Observership if accepted. It should be printed on official letterhead, written in English, signed, and dated within the last 3 months.
                                            </div>
                                            <div>
                                                <FileUpload
                                                    id="losUploaded"
                                                    label={"Upload letter of support"}
                                                    name="losUploaded"
                                                    isRequired={(needLetterOfSupport === 1)}
                                                    numberOfFiles={1}
                                                    fileSize={"2MB"} // default 5MB each file
                                                    fileType={["pdf"]}
                                                    maxFileNameLength={60} //Database column that stores the file name is limited to 100	
                                                    instructionMessage={fileUploadInstructionMessage}
                                                    helpMessage={"File format: .pdf (limit 1 file under 2 MB)"}
                                                    hasError={touched.losUploaded && errors.losUploaded}
                                                    errorMessage={errors.losUploaded}
                                                    uploadApi={fileUploadApi + "los"}
                                                    onChange={(e) => {
                                                        // e is an array of loaded file items
                                                        let tmp = e && e.length > 0 && e[0] !== 'F' && e[0].filename.length < 60;
                                                        setLetterOfSupportUploaded(tmp ? true : false);

                                                        touched.losUploaded = true;
                                                        if (!tmp) {
                                                            if (e.length === 0) {
                                                                setFieldError("losUploaded", losErrorMessage);
                                                            }
                                                            else if (e[0].filename.length > 60) {
                                                                setFieldError("losUploaded", invalidFileLength);	//need to display field error when fileupload on change	
                                                            }
                                                            else {
                                                                setFieldError("losUploaded", invalidFileErrorMessage);	//need to display field error when fileupload on change	
                                                            }
                                                        } else {
                                                            setFieldError("losUploaded", null);
                                                        }

                                                    }}
                                                    onBlur={(e) => { }}
                                                />
                                                <hr className="hr--light" />
                                            </div>
                                        </div>

                                        <div className="div_3_col">
                                            <Button
                                                text={"SUBMIT UPDATED DOCUMENTS"}
                                                styleName={"button button--primary"}
                                                id={"btnSubmit"}
                                                type="submit"
                                                onClick={(e) => {
                                                    setFormSubmitted(true);
                                                    validateForm();
                                                    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </form>
                        </div>

                    )}
                </Formik>
            </div>
        </div>
    );
};

export default UpdateApplicationDocuments;